$(document).ready(function() {

    // Dealership Configurations
    
});
